/**
 * Theme Name: project-sscms v1.511.0
 * Theme URI: git+https://github.com/1debit/project-sscms.git
 * Author: Sharp Notions, LLC
 * Author URI: https://sharpnotions.com
 * Description: Wordpress theme for Chime (project-sscms) [main - 1f45cce37]
 * Version: 1.511.0-2025-07-18T18-36-12
 * License: ISC
 * License URI: "http://www.gnu.org/licenses/gpl-2.0.html"
 */
/**
 * File endpoint-redirect-track.js.
 * Track when endpoint requests result in page redirect
 */
 var redirectingFrom = window.location.href;
 
 function endpointRedirectTrack(referralToken, referralType, status, reason, redirectingTo) {
    const goToUrl = redirect(redirectingTo);
   
    let properties = {
      referral_token: referralToken,
      page_type: referralType,
      endpoint_response_code: status,
      redirect_reason: reason,
      redirecting_url: redirectingFrom,
      redirecting_to: redirectingTo
    };

    segment(
      'track',
      'Landing Page Visitor Redirected',
      properties,
      goToUrl
    );
 }
